import { API } from "../constants/api";
import {
  axiosPostWithToken,
  axiosGetWithToken,
  axiosPut,
  axiosPatchWithToken,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";


export const MP_PROJECT_LAUNCH_LIST = "MP_PROJECT_LAUNCH_LIST";
export const MP_PROJECT_LAUNCH_LOADER = "MP_PROJECT_LAUNCH_LOADER";
export const MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE =
  "MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE";
export const MP_CHANGE_CURRENT_PROJECTLAUNCH_PAGE =
  "MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE";
export const MP_SEARCH_JOBS = "MP_SEARCH_JOBS";
export const MP_CHANGE_CURRENT_PROJECT_PAGE = "MP_CHANGE_CURRENT_PROJECT_PAGE";
export const MP_SET_PROJECT_ITEMS_PER_PAGE = "MP_SET_PROJECT_ITEMS_PER_PAGE";
export const MP_PROJECT_STATUS_FILTER = "MP_PROJECT_STATUS_FILTER";

// Notes
export const MP_LAUNCH_NOTES_LOADER = "MP_LAUNCH_NOTES_LOADER";
export const MP_LAUNCH_NOTES_LIST_SUCCESS = "MP_LAUNCH_NOTES_LIST_SUCCESS";
export const MP_LAUNCH_NOTES_LIST_FAIL = "MP_LAUNCH_NOTES_LIST_FAIL";
export const MP_LAUNCH_NOTE_ADD_SUCCESS = "MP_LAUNCH_NOTE_ADD_SUCCESS";
export const MP_LAUNCH_UPDATE_SUCCESS = "MP_LAUNCH_UPDATE_SUCCESS";

// Renewals
export const MP_RENEWAL_LOADER = "MP_RENEWAL_LOADER";
export const MP_RENEWAL_LIST_SUCCESS = "MP_RENEWAL_LIST_SUCCESS";
export const MP_RENEWAL_LIST_FAIL = "MP_RENEWAL_LIST_FAIL";
export const MP_RENEWAL_ADD_SUCCESS = "MP_RENEWAL_ADD_SUCCESS";
export const MP_RENEWAL_UPDATE_SUCCESS = "MP_RENEWAL_UPDATE_SUCCESS";

// Offers
export const MP_LAUNCH_OFFER_LOADER = "MP_LAUNCH_OFFER_LOADER";
export const MP_LAUNCH_OFFER_LIST_SUCCESS = "MP_LAUNCH_OFFER_LIST_SUCCESS";
export const MP_LAUNCH_OFFER_LIST_FAIL = "MP_LAUNCH_OFFER_LIST_FAIL";
export const MP_LAUNCH_OFFER_ADD_SUCCESS = "MP_LAUNCH_OFFER_ADD_SUCCESS";
export const MP_LAUNCH_DETAILS = "MP_LAUNCH_DETAILS";
export const OFFERS_PER_PAGE = "OFFERS_PER_PAGE";
export const OFFERS_CURRENT_PROJECT_PAGE = "OFFERS_CURRENT_PROJECT_PAGE";
export const MP_SEARCH_OFFERS = "MP_SEARCH_OFFERS";
export const SET_MP_LAUNCH_DATE_FILTER = "SET_MP_LAUNCH_DATE_FILTER";
export const CLEAR_MP_LAUNCH_DATE_FILTER = "CLEAR_MP_LAUNCH_DATE_FILTER";

const buildStatusFilter = (statusus) => {
  if (statusus.length === 1) return { status: String(statusus[0]) };
  if (statusus.length > 1) return { statusus: statusus.map(String) };
  return {};
};


const buildMPLaunchBody = (getState, extra = {}) => {
  const { mpLaunch } = getState();
  return {
    search: mpLaunch.mpLaunchSearchText,
    page_no: mpLaunch.mpLaunchCurrentPage,
    ...buildStatusFilter(mpLaunch.mpLaunchStatusFliter),
    ...extra,
  };
};


const dispatchError = (dispatch, err, fallback = "Something went wrong.") =>
  dispatch({
    type: ERROR_ALERT,
    payload: err?.response?.data?.message || err?.response?.data || fallback,
  });


const downloadCsv = (data, filename) => {
  const blob = new Blob([data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};



export const getMPLaunchList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const {
      mpLaunchCurrentPage,
      mpLaunchSearchText,
      mpLaunchStatusFliter,
      dateFilters,
    } = getState().mpLaunch;

    const bodyData = {
      page_no: mpLaunchCurrentPage,
    };

    if (mpLaunchSearchText) {
      bodyData.search = mpLaunchSearchText;
    }
    // Status handling (your existing logic preserved)
    if (mpLaunchStatusFliter.length === 1) {
      bodyData.status = String(mpLaunchStatusFliter[0]);
    } else if (mpLaunchStatusFliter.length > 1) {
      bodyData.statusus = mpLaunchStatusFliter.map(String);
    }

    // Add ALL applied date filters dynamically
    Object.entries(dateFilters).forEach(([key, value]) => {
      if (value?.length === 2) {
        bodyData[key] = value;
      }
    });

    axiosPostWithToken(API.MP_LAUNCH_LIST, bodyData, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: MP_PROJECT_LAUNCH_LIST,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data || "Something went wrong.",
        });
      });
  };
};

export const exportProjectData =
  (fromDate, toDate) => async (dispatch, getState) => {
    dispatch({ type: MP_PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const bodyData = buildMPLaunchBody(getState, {
      from: fromDate,
      to: toDate,
    });

    axiosPostWithToken(API.MP_LAUNCH_LIST_EXPORT, bodyData, token, {
      responseType: "blob",
    })
      .then((res) => downloadCsv(res.data, "mp-data.csv"))
      .catch((err) => dispatchError(dispatch, err));
  };



export const setItemsPerPage = (value) => async (dispatch) => {
  dispatch({ type: MP_PROJECT_LAUNCH_LOADER });
  dispatch({ type: MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE, payload: value });
};

export const changeCurrentPage = (value) => async (dispatch) => {
  dispatch({ type: MP_PROJECT_LAUNCH_LOADER });
  dispatch({ type: MP_CHANGE_CURRENT_PROJECT_PAGE, payload: value });
};

export const search = (value) => async (dispatch) => {
  dispatch({ type: MP_PROJECT_LAUNCH_LOADER });
  dispatch({ type: MP_SEARCH_JOBS, payload: value });
};

export const setLaunchStatusFliter = (value) => async (dispatch) => {
  dispatch({ type: MP_PROJECT_STATUS_FILTER, payload: value });
};

export const setItemsPerPageOffer = (value) => async (dispatch) => {
  dispatch({ type: MP_PROJECT_LAUNCH_LOADER });
  dispatch({ type: OFFERS_PER_PAGE, payload: value });
};

export const searchOffers = (value) => async (dispatch) => {
  dispatch({ type: MP_PROJECT_LAUNCH_LOADER });
  dispatch({ type: MP_SEARCH_OFFERS, payload: value });
};



export const editNotes = (id, data, refresh) => async (dispatch, getState) => {
  const token = getState().auth.token;

  axiosPostWithToken(`${API.EDIT_PROJECT_NOTES}/${id}`, data, token).then(
    (res) => {
      if (res.data.status_code === 200) {
        dispatch({ type: MP_PROJECT_LAUNCH_LOADER });
        refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Notes updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Error updating User.",
        });
      }
    },
  );
};

export const getLaunchNotes = (launchId) => async (dispatch, getState) => {
  dispatch({ type: MP_LAUNCH_NOTES_LOADER });

  const token = getState().auth.token;

  axiosGetWithToken(`${API.MP_LAUNCH_NOTE_LIST}/${launchId}`, token)
    .then((res) => {
      const { status_code: statusCode, data } = res?.data ?? {};

      if (statusCode === 200 && Array.isArray(data)) {
        dispatch({ type: MP_LAUNCH_NOTES_LIST_SUCCESS, payload: data });
      } else if (statusCode === 404) {
        dispatch({ type: MP_LAUNCH_NOTES_LIST_SUCCESS, payload: [] });
      } else {
        dispatch({ type: MP_LAUNCH_NOTES_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.message || "Failed to load notes.",
        });
      }
    })
    .catch((err) => {
      dispatch({ type: MP_LAUNCH_NOTES_LIST_FAIL });
      dispatchError(
        dispatch,
        err,
        "Something went wrong while fetching notes.",
      );
    });
};

export const addLaunchNote =
  (launchId, note, callback) => async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosPostWithToken(
      `${API.MP_LAUNCH_CREATE_NOTE}/${launchId}/`,
      { notes: note },
      token,
    )
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({ type: MP_LAUNCH_NOTE_ADD_SUCCESS });
          dispatch(getLaunchNotes(launchId));
          callback?.();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.message || "Failed to add note.",
          });
        }
      })
      .catch((err) =>
        dispatchError(dispatch, err, "Something went wrong while adding note."),
      );
  };

export const updateLaunchDetails =
  (launchId, data, callback) => async (dispatch, getState) => {
    const token = getState().auth.token;

    // Normalize empty/undefined fields to null
    const payload = { ...data };
    [
      "latest_start_date",
      "termination_date",
      "tentative_end_date",
      "status",
    ].forEach((field) => {
      if (!payload[field]) payload[field] = null;
    });

    axiosPostWithToken(
      `${API.MP_LAUNCH_LIST_UPDATE}/${launchId}`,
      payload,
      token,
    )
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({ type: MP_LAUNCH_UPDATE_SUCCESS });
          dispatch(getMPLaunchList());
          callback?.();
        } else {
                       console.log(res.data, "ertyui")
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.data?.message || "Failed to update launch.",
          });
        }
      })
      .catch((err) =>
        dispatchError(
          dispatch,
          err,
          "Something went wrong while updating launch.",
        ),
      );
  };


export const getRenewalList = (launchId) => async (dispatch, getState) => {
  dispatch({ type: MP_RENEWAL_LOADER });

  const token = getState().auth.token;

  axiosGetWithToken(`${API.MP_RENEWALS_LIST}/${launchId}/`, token)
    .then((res) => {
      const apiData = res?.data?.data || [];
      if (res?.data?.status_code === 200 && Array.isArray(apiData)) {
        dispatch({ type: MP_RENEWAL_LIST_SUCCESS, payload: apiData });
      } else {
        dispatch({ type: MP_RENEWAL_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.message || "Failed to load renewals.",
        });
      }
    })
    .catch((err) => {
      dispatch({ type: MP_RENEWAL_LIST_FAIL });
      dispatchError(
        dispatch,
        err,
        "Something went wrong while fetching renewals.",
      );
    });
};

export const createMPRenewal =
  (launchId, data, callback) => async (dispatch, getState) => {
    const token = getState().auth.token;

    const bodyData = {
      date_of_renewal: data.date_of_renewal,
      renewal_period: data.renewal_period,
      new_client_pricing: data.new_client_pricing,
      new_candidate_pricing: data.new_candidate_pricing,
      new_job_hours: data.new_job_hours,
      status: data.status,
    };

    axiosPostWithToken(
      `${API.MP_RENEWALS_CREATE}/${launchId}/`,
      bodyData,
      token,
    )
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Renewal created successfully.",
          });
          dispatch(getRenewalList(launchId));
          callback?.();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to create a renewal.",
          });
        }
      })
      .catch((err) =>
        dispatchError(
          dispatch,
          err,
          "Something went wrong while creating a renewal.",
        ),
      );
  };

export const updateMPRenewal =
  (launchId, data, callback) => async (dispatch, getState) => {
    const token = getState().auth.token;

    const bodyData = {
      ...(data.date_of_renewal && { date_of_renewal: data.date_of_renewal }),
      ...(data.renewal_period && { renewal_period: data.renewal_period }),
      ...(data.new_client_pricing && {
        new_client_pricing: data.new_client_pricing,
      }),
      ...(data.new_candidate_pricing && {
        new_candidate_pricing: data.new_candidate_pricing,
      }),
      ...(data.new_job_hours && { new_job_hours: data.new_job_hours }),
      ...(data.status && { status: data.status }),
    };

    try {
      const res = await axiosPut(
        `${API.MP_RENEWALS_UPDATE}/${launchId}/`,
        bodyData,
        token,
      );

      if (res?.data?.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Renewal updated successfully.",
        });
        await dispatch(getRenewalList(launchId));
        dispatch(getMPLaunchList());
        callback?.();
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.message || "Failed to update renewal.",
        });
      }
    } catch (err) {
      dispatchError(
        dispatch,
        err,
        "Something went wrong while updating the renewal.",
      );
    }
  };



export const getOfferList = () => async (dispatch, getState) => {
  dispatch({ type: MP_LAUNCH_OFFER_LOADER });

  const token = getState().auth.token;
  const { mpLaunch } = getState();

  const bodyData = {
    search: mpLaunch.offersSearchText || "",
    page_no: mpLaunch.mpLaunchCurrentPage,
  };

  axiosPostWithToken(API.MP_OFFERS_LIST, bodyData, token)
    .then((res) => {
      const { status_code: statusCode, data: apiData } = res?.data ?? {};

      if (statusCode === 200) {
        dispatch({ type: MP_LAUNCH_OFFER_LIST_SUCCESS, payload: apiData });
      } else if (statusCode === 404) {
        dispatch({ type: MP_LAUNCH_OFFER_LIST_SUCCESS, payload: [] });
      }
    })
    .catch((err) => {
      dispatch({ type: MP_LAUNCH_OFFER_LIST_FAIL });
      dispatchError(
        dispatch,
        err,
        "Something went wrong while fetching offers.",
      );
    });
};


const mutateLaunchOffer =
  (apiUrl, bodyData, successMsg, failMsg) => async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({ type: SUCCESS_ALERT, payload: successMsg });
          dispatch(getMPLaunchList());
          // callback is closed over by the caller — see wrappers below
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || failMsg,
          });
        }
      })
      .catch((err) =>
        dispatchError(
          dispatch,
          err,
          `Something went wrong while ${failMsg.toLowerCase()}.`,
        ),
      );
  };

export const createLaunchOffer =
  (launchId, data, callback) => async (dispatch, getState) => {
    const token = getState().auth.token;

    const bodyData = {
      offer: Number(data.offer),
      offer_end_date: data.offer_end_date,
      notes: data.notes?.trim() || "",
      offer_status: String(data.offer_status),
    };

    axiosPostWithToken(`${API.MP_OFFER_CREATE}/${launchId}/`, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Offer added successfully.",
          });
          dispatch(getMPLaunchList());
          callback?.();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to create offer.",
          });
        }
      })
      .catch((err) =>
        dispatchError(
          dispatch,
          err,
          "Something went wrong while adding offer.",
        ),
      );
  };

export const updateLaunchOffer =
  (launchId, data, callback) => async (dispatch, getState) => {
    const token = getState().auth.token;

    const bodyData = {
      ...(data.offer_end_date && { offer_end_date: data.offer_end_date }),
      ...(data.notes?.trim() && { notes: data.notes.trim() }),
      ...(data.offer_status && { offer_status: String(data.offer_status) }),
    };

    axiosPostWithToken(`${API.MP_OFFER_UPDATE}/${launchId}/`, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Offer updated successfully.",
          });
          dispatch(getMPLaunchList());
          callback?.();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to Update offer.",
          });
        }
      })
      .catch((err) =>
        dispatchError(
          dispatch,
          err,
          "Something went wrong while updating offer.",
        ),
      );
  };

export const createOffer = (data) => async (dispatch, getState) => {
  const token = getState().auth.token;

  axiosPostWithToken(API.CRETAE_OFFERS, data, token)
    .then((res) => {
      if (res?.data?.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Offer Created successfully.",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.message || "Failed to create offer.",
        });
      }
    })
    .catch((err) =>
      dispatchError(dispatch, err, "Something went wrong while adding offer."),
    );
};


export const mpLaunchDetails = (id) => async (dispatch, getState) => {
  const token = getState().auth.token;

  axiosGetWithToken(`${API.MP_LAUNCH_DETAILS}${id}`, token).then((res) => {
    if (res.data.status_code === 200) {
      dispatch({ type: MP_LAUNCH_DETAILS, payload: res.data.data });
    } else {
      dispatch({
        type: ERROR_ALERT,
        payload: res.data.data.message || "Something went wrong.",
      });
    }
  });
};

export const updateIsReplacement = (id, data) => async (dispatch, getState) => {
  const token = getState().auth.token;

  axiosPatchWithToken(
    `${API.IS_REPLACEMENT}${id}/replacement`,
    { is_replacement: data },
    token,
  ).then((res) => {
    if (res.data.status_code === 200) {
      dispatch({ type: SUCCESS_ALERT, payload: "Updated Successfully" });
    } else {
      dispatch({ type: ERROR_ALERT, payload: res.data.data.message });
    }
  });
};
